import { CongSetting, CongSettings } from "../../../types/scheduling/settings";
import { Cong } from "../../../types/cong";
import { useTranslation } from "react-i18next";
import { languageGroupName } from "../../../helpers/langGroups";
import HourglassGlobals from "../../../helpers/globals";
import { Unlock } from "react-bootstrap-icons";
import { MaxSongNumber } from "../../../helpers/util";
import { getWMTemplateHTML } from "../../../helpers/wmTemplates";
import { CheckBox, DDMnumbers, DDMstrings, TemplateEditor, TextArea, TextInput, UserDropdown } from "./settings";

export const SettingsWM = (props: {
  settings: CongSettings;
  setSettings: (set: CongSettings) => void;
  myCong: Cong;
  lgroup: number;
}) => {
  const { t } = useTranslation();
  return (
    <div>
      <CheckBox
        switchType
        settingKey={CongSetting.EnableHospitality}
        settings={props.settings}
        setSettings={props.setSettings}
      />
      <CheckBox
        switchType
        settingKey={CongSetting.HospitalityByGroup}
        settings={props.settings}
        setSettings={props.setSettings}
        disabled={!props.settings.enable_hospitality}
      />
      <CheckBox
        switchType
        settingKey={CongSetting.ShowWTReader}
        settings={props.settings}
        setSettings={props.setSettings}
      />
      <CheckBox
        switchType
        settingKey={CongSetting.ShowInterpreter}
        settings={props.settings}
        setSettings={props.setSettings}
      />
      <TextInput
        settingKey={CongSetting.CongregationDisplayName}
        settings={props.settings}
        setSettings={props.setSettings}
        placeholder={languageGroupName(props.lgroup, props.settings)}
      />
      <TextArea
        settingKey={CongSetting.CongregationPTContactInfo}
        settings={props.settings}
        setSettings={props.setSettings}
        labelIcon={HourglassGlobals.isE2E() ? <Unlock /> : undefined}
      />
      <UserDropdown
        settings={props.settings}
        setSettings={props.setSettings}
        settingKey={CongSetting.WTConductor}
        privilege="wt_conductor"
        lgroup={props.lgroup}
      />
      <TextInput settingKey={CongSetting.OtherSpeakerName} settings={props.settings} setSettings={props.setSettings} />
      <TextInput settingKey={CongSetting.OtherSpeakerCong} settings={props.settings} setSettings={props.setSettings} />
      <TextInput
        settingKey={CongSetting.OtherSpeakerTalkTitle}
        settings={props.settings}
        setSettings={props.setSettings}
      />
      <TextInput
        settingKey={CongSetting.CircuitOverseerName}
        settings={props.settings}
        setSettings={props.setSettings}
      />
      <TextInput
        settingKey={CongSetting.CircuitOverseerWMTalkTitle}
        settings={props.settings}
        setSettings={props.setSettings}
      />
      <TextInput
        settingKey={CongSetting.CircuitOverseerWMServiceTalkTitle}
        settings={props.settings}
        setSettings={props.setSettings}
      />
      <DDMnumbers
        settings={props.settings}
        setSettings={props.setSettings}
        settingKey={CongSetting.CircuitOverseerWMClosingSong}
        options={MaxSongNumber}
        allowZero
        zeroIsBlank
      />
      <DDMstrings
        settings={props.settings}
        setSettings={props.setSettings}
        settingKey={CongSetting.WMPrintDate}
        options={[
          { label: t("general.week_of"), value: "weekof" },
          { label: t("general.day_of"), value: "dayof" },
        ]}
        labelSuffix={t("conganalysis.attendance.weekend")}
      />
      <CheckBox
        switchType
        settingKey={CongSetting.WMSpeakerClosingPrayer}
        settings={props.settings}
        setSettings={props.setSettings}
      />
      <CheckBox
        switchType
        settingKey={CongSetting.HideOutgoingSpeakers}
        settings={props.settings}
        setSettings={props.setSettings}
      />
      <TemplateEditor
        settingKey={CongSetting.WMReminderEmailTemplate}
        content={getWMTemplateHTML(props.settings.wm_reminder_email_template)}
        settings={props.settings}
        setSettings={props.setSettings}
        variables={[
          { name: "speaker", label: t("schedules.weekend.speaker.0") },
          { name: "talkTitle", label: t("schedules.general.talk") },
          { name: "date", label: t("general.date") },
          { name: "time", label: t("schedules.general.meeting-time") },
          { name: "congregation", label: t("list.congregation.title") },
          { name: "sender", label: t("general.from") },
        ]}
      />
    </div>
  );
};
